
import React, { Fragment } from 'react';
import {  Row, Col } from 'reactstrap';
import Select from 'react-select';
import DatePicker from "react-datepicker";
import moment from 'moment';
import { backendDateFormat, fieldDateFormat } from '../../../constants';
export default function CashflowRpt({exportObj, onChangeExportFeature, onChangeExtension, onChangeDate, onChangeDropdown}){
  return(
    <Fragment>
      <div className="export-items">
        <Row className="flex-centered">
          <Col cs="5">
            <div className="">
              <label className="flex-centered export-label">
                <input type="checkbox"
                  onChange={(e) => onChangeExportFeature(e.target.checked, 'cashflow')}
                  checked={exportObj.contracts && exportObj.contracts.cashflow && exportObj.contracts.cashflow.export ? true:false}
                />
                <span>Cashflow Summary</span>
              </label>
            </div>
          </Col>
          <Col cs="4">
            <div className="export-avial">
              <h6>Export Format</h6>
              <ul className="list-inline">
                <li className="list-inline-item">
                  <label>
                    <input
                      name="cashflow"
                      checked={(exportObj.contracts && exportObj.contracts.cashflow && exportObj.contracts.cashflow.extension == 'pdf')}
                      onChange={() => onChangeExtension('pdf', 'cashflow')}
                      type="radio"
                    />
                    <span>PDF</span>
                  </label>
                </li>
                <li className="list-inline-item">
                  <label>
                    <input
                      name="cashflow"
                      checked={(exportObj.contracts && exportObj.contracts.cashflow && exportObj.contracts.cashflow.extension == 'xls')}
                      onChange={() => onChangeExtension('xls', 'cashflow')}
                      type="radio"
                    />
                    <span>XL</span>
                  </label>
                </li>
              </ul>
            </div>
          </Col>
        </Row>
        <div className="filter-avail">
          <ul className="list-inline flex-centered">
            <li className="list-inline-item">
              <label>Start Date</label>
              <DatePicker
                dateFormat = {fieldDateFormat}
                maxDate={moment()}
                selected={exportObj.contracts.cashflow.filter.startDate ? moment(exportObj.contracts.cashflow.filter.startDate): null}
                onChange={(e) => onChangeDate(moment(e).format(backendDateFormat), 'startDate', 'cashflow')}
                showYearDropdown
                showMonthDropdown
                useShortMonthInDropdown
             />
            </li>
            <li className="list-inline-item">
              <label>End Date</label>
              <DatePicker
                dateFormat = {fieldDateFormat}
                maxDate={moment()}
                selected={exportObj.contracts.cashflow.filter.endDate ? moment(exportObj.contracts.cashflow.filter.endDate):null}
                onChange={(e) => onChangeDate(moment(e).format(backendDateFormat), 'endDate', 'cashflow')}
                showYearDropdown
                showMonthDropdown
                useShortMonthInDropdown
              />
            </li>
            <li className="list-inline-item">
              <label>Transaction Type</label>
              <Select
                  name="form-field-name"
                  value={exportObj.contracts.cashflow.filter.transaction_type}
                  options={[{label: 'MR Transaction', value: '1'}, {label: 'Rental Transaction', value: '2'},{label: 'Penalty Transaction', value: '3'},{label: 'Debit Note Transaction', value: '4'},{label: 'Credit Note Transaction', value: '5'}]}
                  placeholder = 'Select Transaction Type'
                  onChange={(data) => onChangeDropdown(data, 'transaction_type', 'cashflow')}
              />
            </li>
          </ul>
        </div>
      </div>
    </Fragment>
  )
}
